import { render, staticRenderFns } from "./VerticalAnimation.vue?vue&type=template&id=3d4efb07&scoped=true&"
import script from "./VerticalAnimation.vue?vue&type=script&lang=js&"
export * from "./VerticalAnimation.vue?vue&type=script&lang=js&"
import style0 from "./VerticalAnimation.vue?vue&type=style&index=0&id=3d4efb07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4efb07",
  null
  
)

export default component.exports